import { Checkbox, FormControlLabel } from "@mui/material";
import { ChangeEvent, FC } from "react";
import { useTranslation } from "react-i18next";

export interface AnonymizeUsageDataCheckboxProps {
  value: boolean | null | undefined;
  onChange: (value: boolean) => void;
}

export const AnonymizeUsageDataCheckbox: FC<AnonymizeUsageDataCheckboxProps> = (
  props
) => {
  const { t } = useTranslation("shared-ts-posthog");
  const handleConsentCheckboxChange = (
    event: ChangeEvent,
    checked: boolean
  ) => {
    props.onChange(checked);
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={props.value ?? undefined}
          onChange={handleConsentCheckboxChange}
        />
      }
      label={t("Anonymize my usage data")}
    />
  );
};
